import React, { useEffect, useRef, useState } from "react";
import { Table, Modal, Checkbox, Button } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import config from "appConfig";
import styles from "./manageReportPage.scss";
import { getReports, updateReport, toggleBlockAd } from "./report.ducks";
import { formatDate } from "../../../services";
import { AdReportReason, PageRoute, AdStatus } from "../../../models/enums";
import { IndexPagination } from "../../../components/IndexPagination";
import PageTitle from "../PageTitle";
import ReportFilterForm from "./ReportFilterForm";
import { mapCategoryToHr, mapModuleToHr } from "../../LanguageMapper";

const ManageReportPage = props => {
  const { page, itemPerPage, total, filters, reports, modules } = props;
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState({}); // preserve current filters

  const columns = [
    {
      title: "Kod",
      dataIndex: "adCode",
      key: "code",
      width: 100
    },
    {
      title: "Naziv",
      dataIndex: "adTitle",
      key: "title",
      render: (value, record) => (
        <Link
          title={value}
          target="_blank"
          className={styles.link}
          to={`/${mapModuleToHr(record.module)}/${mapCategoryToHr(
            record.category,
            record.module
          )}${PageRoute.details}/${record.smartLink}/${record.adCode}`}
        >
          {value}
        </Link>
      )
    },
    {
      title: "Reporter",
      dataIndex: "reporter",
      key: "reporter",
      render: (value, record) => (
        <Link
          title={record.reporterEmail}
          target="_blank"
          className={styles.link}
          to={`/admin/user/profile/${record.reporterId}`}
        >
          {record.reporterEmail}
        </Link>
      )
    },
    {
      title: "Vlasnik",
      dataIndex: "owner",
      key: "owner",
      render: (value, record) => (
        <Link
          title={record.reporteeEmail}
          target="_blank"
          className={styles.link}
          to={`/admin/user/profile/${record.reporteeId}`}
        >
          {record.reporteeEmail}
        </Link>
      )
    },
    {
      title: "Datum prijave",
      dataIndex: "reportedDate",
      key: "reportedDate",
      render: value => formatDate(value)
    },
    {
      title: "Razlog",
      dataIndex: "reason",
      key: "reason",
      width: 150,
      render: value =>
        AdReportReason.find(reason => reason.value === value).name
    },
    {
      title: "Opis",
      dataIndex: "description",
      key: "description",
      render: value => (
        <a
          href="#"
          onClick={() =>
            Modal.info({
              title: "Opis",
              content: value,
              width: props.descriptionPopupWidth,
              className: styles.descriptionExpanded
            })
          }
          className={styles.description}
        >
          {value}
        </a>
      ),
      width: props.descriptionColumnWidth
    },
    {
      title: "E-mail poslan",
      dataIndex: "emailSentDate",
      key: "emailSentDate",
      align: "center",
      width: 100,
      render: (value, { id }) => (
        <div className={`child-center ${styles.emailSentStyle}`}>
          <Checkbox
            onChange={e => handleEmailSentClick(id, e.target.checked)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },
    {
      title: "Riješeno",
      dataIndex: "solvedDate",
      key: "solvedDate",
      align: "center",
      width: 100,
      render: (value, { id }) => (
        <div className={`child-center ${styles.solved}`}>
          <Checkbox
            onChange={e => handleSolvedClick(id, e.target.checked)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },
    {
      title: "Blokiraj/Odblokiraj",
      key: "block",
      dataIndex: "adId",
      align: "center",
      render: (value, { adStatus }) => (
        <Button
          type="danger"
          onClick={() => props.toggleBlockAd(adStatus, value)}
        >
          {adStatus === AdStatus.blocked
            ? "Odblokirati"
            : "Blokirati"}
        </Button>
      )
    }
  ];

  useEffect(() => {
    props.getReports(filters, page, itemPerPage);
  }, []);

  const onPageChange = page => {
    props.getReports(currentFilters, page, itemPerPage);
  };

  const handleSearch = filters => {
    setCurrentFilters(filters);
    props.getReports(filters, 1, itemPerPage);
  };

  const handleEmailSentClick = (id, value) => {
    const report = reports.find(report => report.id === id);
    const solvedDate = report.solvedDate;

    const data = {
      emailSentDate: value ? new Date().toISOString() : null,
      solvedDate: solvedDate
    };

    setLoading(true);
    props.updateReport(id, data, reports, () => {
      props.getReports(filters, page, itemPerPage).then(() => setLoading(false));
    });
  };

  const handleSolvedClick = (id, value) => {
    const report = reports.find(report => report.id === id);
    const emailSentDate = report.emailSentDate;

    const data = {
      solvedDate: value ? new Date().toISOString() : null,
      emailSentDate: emailSentDate
    };

    setLoading(true);
    props.updateReport(id, data, reports, () => {
      props.getReports(filters, page, itemPerPage).then(() => setLoading(false));
    });
  };


  return (
    <React.Fragment>
      <PageTitle title={"Prijave"} />
      <ReportFilterForm
        value={filters}
        modules={modules}
        onSubmit={handleSearch}
        className=""
      />
      <Table
        dataSource={reports}
        // @ts-ignore
        columns={columns}
        pagination={false}
        bordered
        rowKey="id"
        className="admin-table"
        loading={loading}
      />
      {reports.length > 0 ? (
        <IndexPagination
          total={total}
          page={page}
          itemPerPage={itemPerPage}
          onPageChange={onPageChange}
        />
      ) : null}
    </React.Fragment>
  );
};

ManageReportPage.defaultProps = {
  descriptionPopupWidth: 800,
  descriptionColumnWidth: 200
};

export default connect(
  state => ({
    // @ts-ignore
    ...state.admin.report,
    // @ts-ignore
    modules: state.global.modules
  }),
  {
    getReports,
    updateReport,
    toggleBlockAd
  }
)(ManageReportPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageReportPage/ManageReportPage.tsx